import { ShieldCheck, Sparkles, Zap } from 'lucide-react'

import { cn } from '@/utils'

const VALUE_PROPS = [
  {
    icon: Zap,
    title: 'Weeks of analysis in minutes',
    body: 'Upload statements from any bank. Every transaction is pulled, categorized, and ready to work.',
  },
  {
    icon: Sparkles,
    title: 'Court-ready reports',
    body: 'Forensic accounting without the consultant fees or the wait. Ask questions, get charts and exhibits back.',
  },
  {
    icon: ShieldCheck,
    title: 'Numbers you can stand behind',
    body: 'Self-healing reconciliation balances each statement to its own printed totals before you export.',
  },
]

export const ValueProps = ({ className }: { className?: string }) => (
  <ul className={cn('grid grid-cols-1 gap-4', className)}>
    {VALUE_PROPS.map(({ icon: Icon, title, body }) => (
      <li key={title} className="flex items-start gap-3">
        <Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand" />
        <div>
          <h3 className="text-sm font-semibold tracking-tight">{title}</h3>
          <p className="text-sm text-muted-foreground text-pretty">{body}</p>
        </div>
      </li>
    ))}
  </ul>
)
